/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC } from 'react';
import { Attachment as AttachmentType } from '@/data/types/Product';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { attachmentContainerSX } from '@/components/blocks/Attachment/styles/container';
import { kebabCase } from 'lodash';
import { useLocalization } from '@/data/Localization';
import { attachmentCardActionsButtonSX } from './styles/cardActionsButton';
import { GetAppRounded } from '@mui/icons-material';
import { AttachmentIcon } from '@/components/blocks/Attachment/parts/Icon';

type Props = {
	attachments: AttachmentType[];
};

export const Attachment: FC<Props> = ({ attachments }) => {
	const filesNLS = useLocalization('Files');
	return(
	<Grid container spacing={2} sx={attachmentContainerSX}>
		{attachments.map((attachment) => (
			<Grid key={attachment.attachmentAssetID} item xs={12} sm={4} md="auto" rowGap={1}>
				<Typography fontWeight="bold">{attachment.name}</Typography>
				<Stack direction="row" alignItems="center" columnGap={3}>
					<Typography variant="body2" color="textSecondary" component="p" mt={0.5}>
						{attachment.name.indexOf("pdf")!=-1?<AttachmentIcon fileExtension={"PDF"} />:			
						<AttachmentIcon fileExtension={attachment.mimeType} /> }			
					</Typography>
					<Button
						data-testid={`product-attachment-${kebabCase(attachment.name)}`}
						id={`product-attachment-${kebabCase(attachment.name)}`}
						color="secondary"
						size="small"
						variant="text"
						href={`${attachment.attachmentAssetPath}`}
						target='_blank'
						download={`${attachment.name}`}
						sx={attachmentCardActionsButtonSX}
						aria-label={`${filesNLS.Download.t()} ${attachment.name}`}
					>
						<GetAppRounded />
					</Button>
				</Stack>
			</Grid>
		))}
	</Grid>
)};
